import type { LucideIcon, LucideProps } from 'lucide-react'
import { cn } from '@/lib/utils'

type UiIconProps = Omit<LucideProps, 'size' | 'children'> & {
  icon: LucideIcon
  size?: 16 | 20 | 24
  directional?: boolean
}

/** Decorative UI glyph. Its control or adjacent text supplies the label. */
export function UiIcon({ icon: Glyph, size = 20, directional = false, className, ...props }: UiIconProps) {
  return (
    <Glyph
      {...props}
      size={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      className={cn('shrink-0', directional && 'rtl:-scale-x-100', className)}
    />
  )
}
